export default __webpack_public_path__ + "static/media/cover_3.f36504b3.jpg";